import {
  buildDefaultPanelMenuPermissions,
  normalizePanelMenuPermissions,
  USER_CORE_PERMISSION_BADGES,
} from "@/utils/panelMenuPermissions";

export const PANEL_ROLE_GOREV_OPTIONS = [
  { value: "", label: "— Görev yok (manuel kapsam)" },
  { value: "call_center_yonetici", label: "Call Center Yönetici" },
  { value: "takim_lideri", label: "Takım Lideri" },
  { value: "dataci", label: "Datacı" },
  { value: "kalite", label: "Kalite Ekibi" },
  { value: "yonetici", label: "Yönetici" },
  { value: "asistan", label: "Asistan" },
];

export const CORE_PERMISSION_FIELDS = USER_CORE_PERMISSION_BADGES.map((item) => ({
  key: item.key,
  label: item.title || item.label,
}));

export const emptyPanelRoleForm = () => ({
  ad: "",
  slug: "",
  description: "",
  gorev: "",
  sort_order: 100,
  core_permissions: CORE_PERMISSION_FIELDS.reduce((acc, item) => {
    acc[item.key] = item.key === "ses_kaydi_goster" || item.key === "arama_yetkisi" || item.key === "excel_indirme" ? 1 : 0;
    return acc;
  }, {}),
  panel_menu_permissions: buildDefaultPanelMenuPermissions(0),
});

export const roleToFormState = (role) => ({
  ad: role?.ad || "",
  slug: role?.slug || "",
  description: role?.description || "",
  gorev: role?.gorev || "",
  sort_order: role?.sort_order ?? 100,
  core_permissions: {
    ...emptyPanelRoleForm().core_permissions,
    ...(role?.core_permissions || {}),
  },
  panel_menu_permissions: role?.panel_menu_permissions
    ? normalizePanelMenuPermissions(role.panel_menu_permissions, { defaultValue: 0 })
    : buildDefaultPanelMenuPermissions(0),
});

export const applyPanelRoleToUserDraft = (role, currentForm = {}) => {
  if (!role) return currentForm;
  const next = { ...currentForm };
  if (role.gorev) next.gorev = role.gorev;
  next.panel_role_id = role.id;
  Object.entries(role.core_permissions || {}).forEach(([key, val]) => {
    next[key] = val ? 1 : 0;
  });
  if (role.panel_menu_permissions && Object.keys(role.panel_menu_permissions).length > 0) {
    next._panel_menu_permissions = normalizePanelMenuPermissions(role.panel_menu_permissions, { defaultValue: 0 });
  }
  return next;
};

export const slugifyRoleName = (name) => String(name || "")
  .toLowerCase()
  .trim()
  .replace(/[^a-z0-9]+/g, "_")
  .replace(/^_+|_+$/g, "")
  .slice(0, 48);

export const panelRoleLabel = (roles, roleId) => {
  if (!roleId) return "—";
  const role = (roles || []).find((r) => String(r.id) === String(roleId));
  return role?.ad || `#${roleId}`;
};
